import { graphql } from '@prophecy/graphql-types/graphql';
export const checkGitTokenValidityQuery = graphql(`
  query checkGitTokenValidity($projectUID: String!) {
    checkGitTokenValidity(projectUID: $projectUID) {
      readAccess
      writeAccess
      diagnostics
    }
  }
`);
